export const RegisterActionTypes = {
  // SET_BASIC_DETAILS_SUBMITTED_STATUS: "SET_BASIC_DETAILS_SUBMITTED_STATUS",
  // SET_STATUTORY_DETAILS_SUBMITTED_STATUS: "SET_STATUTORY_DETAILS_SUBMITTED_STATUS",
  SET_REGISTRATION_DATA: "SET_REGISTRATION_DATA",
};
